<template>  
  <router-view></router-view>

  <div class="main-body">
   <MainHeader/>

   <div id="main-content-list">
    <!---<button onclick="moreContent()">More Content</button>-->


    <div class="first-title-blck" :style="'background-color:'+postBg[0]">
      <div v-if="firstReviewTitle.length>0" class="review-title">
        <span v-if="parseInt(commentPageNum(0)) > 0"><a class="title-link" :href="'../reviews/?p='+reviewId">re: {{firstReviewTitle}}</a></span>
        <span v-else>{{firstReviewTitle}}</span>
      </div>
    </div>


  <div v-for="(review,i) in contentList" :key="review">

    
      
      <div v-if="i>0" class="search-form-blck" :style="searchBlockStyle(i,postBg)">
       <SearchBlock :post_id="review['main'][0].ID"/>
      </div>

     <div :id="'content-blck-'+review['main'][0].ID" :class="'content-blck'+firstContentBlck(i)+contentCornerStyle(i)" :style="'background-color:'+postBg[i]">
  
     <div v-if="!review['main'][0].IDnum && review['main'][0].no_cost !=1 && i>0" :id="'review-top-banner-'+review['main'][0].ID" class="review-top-banner"></div>


     <div :class="i>1 ? 'content-mask':''">
      <div v-if="i<1" class="category-menu">
         <a href="https://www.reviewstream.com" title="ReviewStream.com - consumer reviews"><span class="category-menu-website">ReviewStream.com</span></a>
         <span class="category-menu-raquo">&raquo;</span>
         <a :href="'../reviews/?cat='+review['main'][0].post_category" :title="'Reviews on '+review['category_description']"><span class="category-menu-category">{{review['category_description']}}</span></a>
      </div>        
      
 
      <div :id="'content-title-'+review['main'][0].ID">

          <div v-if="i>0" class="review-title" :id="'title-'+review['main'][0].ID">
              {{review['main'][0].post_title}}
          </div>


          <div v-if="review['main'][0].location" class="location-address">
              {{review['main'][0].location}}
          </div>
      </div>

      <div v-html="review['main'][0].videoCode" v-if="review['main'][0].videoCode" class="video-trailer"></div>   
  

    <div v-if="(i==0 && parseInt(commentPageNum(i)) == 0) || i>0">
  

      <div class="summary-blck" :id="'summary-blck-'+review['main'][0].ID">
          <div v-if="review['main'][0].summary1" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-1'">
           <div id="summary-1-txt">{{review['main'][0].summary1}}</div>
           <div v-if="i<2" class="summary-btns">
             <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 1, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
             <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 1, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
           </div>  

              <!---- dynamically add comment form on summary Reply button click --->
               <div v-if="showSummaryCommentsForm(review['main'][0].ID, 1, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                  <SummaryCommentForm :post_id="review['main'][0].ID" :summary="1"/>
                   <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',1,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
               </div>
 
               <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-1')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-1',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>


          </div>



          <div v-if="isMobile() && !review['main'][0].IDnum && review['main'][0].no_cost !=1 && i==0" :id="'review-top-banner-'+review['main'][0].ID" class="review-top-banner top-banner-mobile"></div>
         
          <div v-if="review['main'][0].summary2" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-2'">
           <div id="summary-2-txt">{{review['main'][0].summary2}}</div>
           <div v-if="i<2" class="summary-btns">
             <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 2, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
             <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 2, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
           </div> 
              <!---- dynamically add comment form on summary Reply button click --->
               <div v-if="showSummaryCommentsForm(review['main'][0].ID, 2, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                  <SummaryCommentForm :post_id="review['main'][0].ID" :summary="2"/>
                   <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',2,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
               </div>
              <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-2')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-2',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>

          </div>
          <div v-if="review['main'][0].summary3" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-3'">
           <div id="summary-3-txt">{{review['main'][0].summary3}}</div> 
           <div v-if="i<2" class="summary-btns">
             <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 3, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
             <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 3, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
           </div>  
               <!---- dynamically add comment form on summary Reply button click --->
               <div v-if="showSummaryCommentsForm(review['main'][0].ID, 3, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                  <SummaryCommentForm :post_id="review['main'][0].ID" :summary="3"/>
                   <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',3,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
               </div>
               <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-3')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-3',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>

          </div>
          <div v-if="review['main'][0].summary4" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-4'">
           <div id="summary-4-txt">{{review['main'][0].summary4}}</div> 
           <div v-if="i<2" class="summary-btns">
             <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 4, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
             <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 4, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
           </div>  
               <!---- dynamically add comment form on summary Reply button click --->
               <div v-if="showSummaryCommentsForm(review['main'][0].ID, 4, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                  <SummaryCommentForm :post_id="review['main'][0].ID" :summary="4"/>
                   <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',4,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
               </div>
               <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-4')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-4',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>
       
          </div>
          <div v-if="review['main'][0].summary5" class="summary-txt" :id="'summary-txt-'+review['main'][0].ID+'-5'">
           <div id="summary-5-txt">{{review['main'][0].summary5}}</div> 
           <div v-if="i<2" class="summary-btns">
             <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 5, 1, summaryCommentFormShown)" :id="'summary-1-btn-'+review['main'][0].ID">agree</button>
             <button class="summary-reply-btn" @click="addSummaryCommentForm(review['main'][0].ID, 5, 2, summaryCommentFormShown)" :id="'summary-2-btn-'+review['main'][0].ID">disagree</button>
           </div>  
               <!---- dynamically add comment form on summary Reply button click --->
               <div v-if="showSummaryCommentsForm(review['main'][0].ID, 5, summaryCommentFormShown)" class="summary-comment-form" :id="'addSummaryCommentBlck-'+review['main'][0].ID">
                  <SummaryCommentForm :post_id="review['main'][0].ID" :summary="5"/>
                   <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'',5,summaryCommentFormShown,summaryCommentGreetingShown, showSummaryCommentGreeting(summaryCommentGreetingAll))">submit</button>
               </div>
               <div v-if="summaryCommentGreetingShown.find(x => x.summary === review['main'][0].ID+'-5')" v-html="fetchSummaryCommentGreeting(review['main'][0].ID+'-5',summaryCommentGreetingShown)" class="summaryCommentGreetingBlck"></div>

          </div>
       </div>   

       <div v-if="!isMobile() && !review['main'][0].IDnum && review['main'][0].no_cost !=1 && i==0" :id="'review-top-banner-'+review['main'][0].ID" class="review-top-banner"></div>

       <div :id="'content-txt-'+review['main'][0].ID" class="content-txt">

           <div v-if="review['main'][0].main_pic && review['main'][0].submType == 0" class="blck-main-pic">
             <picture>
               <source :srcset="'../images_items_webp/'+imageWebpFileName(review['main'][0].main_pic)" type="image/webp">

               <source :srcset="'../images_items/'+review['main'][0].main_pic" type="image/jpeg"> 

               <img :width="review['main'][0].picwidth" :height="review['main'][0].picheight" :src="'../images_items/'+review['main'][0].main_pic" :alt="'Personal review of '+review['main'][0].post_title" :title="'Personal review of '+review['main'][0].post_title" loading="lazy"/>
             </picture>
           </div>

           <div v-html="review['main'][0].post_content"  class="review-content" :id="'review-'+review['main'][0].ID"></div>
       </div>        
       <div class="review-credentials" v-if="i<2">
              <div class="author-name" v-if="review['main'][0].nick">by @{{review['main'][0].nick}}</div>
              <div class="author-name" v-else>by @anonymous</div>
         <div class="author-blck">
           <div class="byauthor">
              <div v-if="review['main'][0].photo_url" class="author-pic">
                 <img :src="'../authors/images/'+review['main'][0].photo_url" :title="'Review author: '+review['main'][0].nick" :alt="'Review author: '+review['main'][0].nick" loading="lazy"/>
              </div>
              <div v-else class="opacity-01">
    
                       <picture>
                          <source srcset="./assets/icons/ghost.webp" type="image/webp">
                          <source srcset="./assets/icons/ghost.jpg" type="image/jpeg"> 
                          <img width="200" height="120" src="./assets/icons/ghost.jpg" alt="anonymous author" title="anonymous author" loading="lazy"/>
                       </picture>




              </div>  
              <div class="trust-block">
                  <TrustChart :trust_data="Math.round(review['main'][0].TR)" :center_color="postBg[i]"/>

              </div>
           </div> 
         </div>
  


          <div class="voting-blck">
              <div class="like-blck" :id="'like-review-'+review['main'][0].ID" @click="likeSubmit('1',review['main'][0].ID,review['review_voting_url'][0])">
                <img class="like-img" alt="LIKE" title="LIKE review" src="./assets/icons/likes/like-review.png" loading="lazy"/>
                <div class="like-thanks" :id="'like-thanks-'+review['main'][0].ID">Thank you :)</div>
              </div>
              <div class="dislike-blck" :id="'dislike-review-'+review['main'][0].ID" @click="likeSubmit('2',review['main'][0].ID,review['review_voting_url'][1])">
                <img class="dislike-img" alt="DISLIKE" title="DISLIKE review" src="./assets/icons/likes/dislike-review.png" loading="lazy"/>
                <div class="dislike-thanks" :id="'dislike-thanks-'+review['main'][0].ID">Thank you :)</div>
              </div>
              
          </div>  
        </div>
    </div>


      <!---QUESTIONS AND ANSWERES-->
      <div class="comments-blck-title" :id="'comments-blck-'+review['main'][0].ID"><img class="chat-icon" src="./assets/icons/chat-icon.png?v=1" alt="Questions, Answers, Comments"/>Questions, Answers, Comments</div>
   
  
      
     <div v-for="(commentsCluster,clusterKey) in review['comments']" :key="clusterKey" class="cluster-wrapper">
        <div class="cluster-vote-wrapper">
           <div v-for="(comment,ii) in commentsCluster" :key="ii" class="commentsBlck" :id="'commentBlck-'+comment.relations">
            

            <a class="aname" :name="comment.relations"></a>
            <div v-if="comment.relations" :class="isClusterStart(comment.relations)" :id="'commentsClusterBlck-'+comment.relations">

                <div v-html="commentBy(comment.comment_by, comment.comment_author)" class="comment-author-blck"></div>  
                <div v-html="postComment(comment.comment_content)"></div>


               <div class="comment-btns">
                  <div class="comments-btns-reply">
                    <button v-if="i<2" class="comment-reply-btn" @click="addReplyCommentForm(comment.relations,replyCommentFormShown)" :id="'reply-btn-'+comment.relations" :data-realtions="comment.relations">Reply</button>
                  </div>
                  <div class="comment-btns-social">
                    <div class="comment-btns-social-twitter">
                     <a target="_blank" :href="'https://twitter.com/intent/tweet?url=https%3A%2F%2Freviewstream.com%2Freviews%2F%3Fp%3D'+review['main'][0].ID+'%23'+comment.relations">


                       <picture>
                          <source srcset="./assets/icons/twitter_icon.webp" type="image/webp">
                          <source srcset="./assets/icons/twitter_icon.png" type="image/jpeg"> 
                          <img width="40" height="40" src="./assets/icons/twitter_icon.png" alt="Twitter share" title="Twitter share" loading="lazy"/>
                       </picture>


                     </a>
                   </div>
                   <div class="comment-btns-social-facebook">
                     <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Freviewstream.com%2Freviews%2F%3Fp%3D'+review['main'][0].ID+'%23'+comment.relations">
                      <picture>
                          <source srcset="./assets/icons/facebook_icon.webp" type="image/webp">
                          <source srcset="./assets/icons/facebook_icon.png" type="image/jpeg"> 
                          <img width="40" height="40" src="./assets/icons/facebook_icon.png" alt="Facebook share" title="Facebook share" loading="lazy"/>
                       </picture>
                    
                     </a>
                   </div>
                </div>
             </div>    

             <div v-if="i<2 && commentBannerToShowAll.indexOf(comment.relations)>-1" class="inner-banner comment-banner" :id="'comment-banner-'+comment.relations"></div>

             <!--- show newly added replies to other comments --->
              <div v-for="(newcomment,iii) in addedComments" :key="iii" class="commentsBlck">
               <div v-if="review['main'][0].ID == addedComments[iii].post_id && comment.relations == addedComments[iii].relation_id" class="commentsClusterBlck">
                 <div v-html="commentBy('', addedComments[iii].author)" class="comment-author-blck"></div>
                 <div v-html="addedComments[iii].newcomment"></div>
                 <div class="greeting-message" v-html="addedComments[iii].greetingMsg"></div>
               </div>   
              </div>

  
               <!---- dynamically add comment form on Reply button click --->
               <div v-if="replyCommentFormShown.indexOf(comment.relations)>-1" :id="'addReplyCommentBlck-'+comment.relations" class="relative">
                  <ReplyCommentForm :relation="comment.relations" :post_id="review['main'][0].ID" :addedComments="addedComments" :submitCommentParent="submitComment" :count="i"/>
               </div>

 
            </div>   

             <div v-if="ii == commentsCluster.length - 1" class="cluster-vote-blck">
                <div class="cluster-vote-title">helpful ?</div>
                <div class="cluster-vote-arrow" v-on:click="clusterHelpfulVote(comment.relations, '2')">NO</div>
                <div class="cluster-vote-arrow" v-on:click="clusterHelpfulVote(comment.relations, '1')">YES</div>
                <div class="cluster-vote-result" :id="'cluster-vote-'+comment.relations">{{comment.claster_score}}</div>
             </div>


         </div>


        </div>



      </div>
          <!--- show newly added comments to the whole review --->
           <div v-for="(newcomment,c) in addedComments" :key="c" class="commentsBlck">
            <div v-if="review['main'][0].ID == addedComments[c].post_id && addedComments[c].relation_id == ''" class="commentsClusterBlck">
              <div v-html="commentBy('', addedComments[c].author)" class="comment-author-blck"></div>
              <div v-html="addedComments[c].newcomment"></div>
              <div class="greeting-message" v-html="addedComments[c].greetingMsg"></div>  
            </div> 
           </div>


        <div v-if="i<2 && review['main'][0].total_clusters > commentClusterPerPage" class="more-comments-blck">
             <MoreCommentsButtons 
                   :post_id="review['main'][0].ID" 
                   :total_comments="review['main'][0].total_comments" 
                   :total_clusters="review['main'][0].total_clusters" 
                   :cluster_perpage="commentClusterPerPage" 
                   :pageNum="commentPageNum(i)"/> 
        </div>


        <div v-if="i<2">
         <input name="comment-author-input" class="comment-details-input comment-blck-top" :id="'comment-author-input-'+review['main'][0].ID" placeholder="Your name (required)" />
         <input name="comment-author-email-input" class="comment-details-input" :id="'comment-author-email-input-'+review['main'][0].ID" placeholder="Your email (required for the review author)"/>
         <textarea name="comment-input" class="comment-input" :id="'comment-input-'+review['main'][0].ID" placeholder="Share your thoughts. Ask. Your opinion is valuable."></textarea>  
         <button class="comment-input-btn" :id="'comment-input-btn-'+review['main'][0].ID" v-on:click="submitComment(review['main'][0].ID,addedComments,'')">submit comment</button>
        </div>



 
      </div>

      <div v-if="i<2" class="related-blck-title" :id="'related-blck-'+review['main'][0].ID"><img class="related-icon" src="./assets/icons/related.png?v=1" alt="related reviews icon" title="related reviews icon" loading="lazy"/>Related reviews</div>
   
      <div v-if="i<2" class="bottom-related-blck">
         <div v-for="related in relatedContentRightColumn.slice(0, 5)"  v-bind:key="related">
          <a :href="related.related_link" :title="related.related_title" :alt="related.related_title" class="bottom-related-link">
           <div class="bottom-rel-title">
            {{ related.related_title }}
           </div>
          </a> 
         </div> 

      </div>


        <div v-if="i<2" class="content-blck-bottom" ></div>




        <a v-if="i>=2" :href="'../reviews/?p='+review['main'][0].ID" :title="review['main'][0].post_title">
         <div v-if="i>=2" class="bottom-onblur" @click="ReadMoreClicked($event)">
          <div class="bottom-onblur-top">
           <div class="read-more-arrow-blck">
            <div class="arrow-box"><div class="arrow-body"><span class="arrow-right"></span></div></div> 
           </div>
           <div class="read-more-txt-blck">   
            <div class="read-more-txt-1">don't hesitate to</div>
            <div class="read-more-txt-2"><div class="read-more-txt-2-blck">READ MORE</div></div>
            <div class="read-more-txt-3">for free</div>
           </div> 
          </div> 
          <div class="bottom-onblur-middle">
            <div class="bottom-onblur-middle-blck-empty"></div>
            <div class="bottom-onblur-middle-blck">
               <div class="bottom-onblur-middle-blck-words">{{review['main'][0].words_count}} words</div>
               <div v-if="review['main'][0].total_comments>0" class="bottom-onblur-middle-blck-comments">{{review['main'][0].total_comments}} {{commentsCountText(review['main'][0].total_comments)}}</div>
            </div>
            
          </div>
           
          <div class="bottom-onblur-bottom"></div>

         </div>
        </a>

       
      </div>
    </div>





   </div>





   <div class="related-column">
       <ul class="related-blck-permanent">
        <li v-for="related in relatedContentRightColumn"  v-bind:key="related">
          <a :href="related.related_link" :title="related.related_title">
          <div class="right-rel-title">
            {{ related.related_title }}
          </div>

          <div v-if="related.related_pic">
             <picture>
               <source :srcset="'../images_items_webp/'+imageWebpFileName(related.related_pic)" type="image/webp">
               <source :srcset="'../images_items/'+related.related_pic" type="image/jpeg"> 
               <img :src="'../images_items/'+related.related_pic" :width="(related.pic_width*0.6)" :height="(related.pic_height*0.6)" :alt="related.related_title" :title="related.related_title" loading="lazy"/>
             </picture>
          </div>

          <div class="right-summary-blck">
           <div v-if="related.summary1" class="right-summary">&bull; {{ related.summary1 }}</div>
           <div v-if="related.summary2" class="right-summary">&bull; {{ related.summary2 }}</div>
           <div v-if="related.summary3" class="right-summary">&bull; {{ related.summary3 }}</div>
           <div v-if="related.summary4" class="right-summary">&bull; {{ related.summary4 }}</div>
           <div v-if="related.summary5" class="right-summary">&bull; {{ related.summary5 }}</div>
           <div class="right-summary-out-icon"><vue-feather type="arrow-right-circle" size="2.5rem" stroke-width="1"></vue-feather></div>
           </div>
         </a>
        </li>
      </ul>
   </div>
   

  </div>

  <!----
     <transition name="slide">
      <div v-if="showBanner" class="cookie-warning">
        <p>ReviewStream uses browser cookies to give you the best possible experience. To make ReviewStream work, we log user data and share it with processors. To use ReviewStream, you must agree to our <a href="/privacy.php" target="_blank" title="Privacy policy">privacy policy</a>.
        </p>
        <button class="cookie-warning-btn" @click="okBannerClicked">I agree</button>
       
      </div>
    </transition>
  --->
 
</template>

<script>
  import MainHeader from './components/MainHeader.vue'
  import SearchBlock from './components/SearchBlock.vue'
  import TrustChart from './components/TrustChart.vue'
  import ReplyCommentForm from './components/ReplyCommentForm.vue'
  import SummaryCommentForm from './components/SummaryCommentForm.vue'
  import MoreCommentsButtons from './components/MoreCommentsButtons.vue'
  import useCookies from './components/useCookies.vue'
  import {fade,unfade} from '@/assets/js/global.js'

  import {defineAsyncComponent, inject, defineComponent} from 'vue'
  import { ref, onBeforeMount, onUnmounted, onMounted } from 'vue'
  import {unescape} from 'html-escaper'
  import { gsap } from "gsap"
  import { ScrollTrigger } from "gsap/ScrollTrigger"
  gsap.registerPlugin(ScrollTrigger)

  const VueFeather = defineAsyncComponent(() =>
     import('vue-feather')
  )


 

  
  //function shuffleBackgroundColor(bgcolors){
  //    let newbgcolors = [...bgcolors];
  //    const getRandomValue = (i, N) => Math.floor(Math.random() * (N - i) + i);
  //    newbgcolors.forEach( (elem, i, arr, j = getRandomValue(i, arr.length)) => [arr[i], arr[j]] = [arr[j], arr[i]] );
  //    return newbgcolors;
  //}




  export default defineComponent({
    components: {
      VueFeather,
      SummaryCommentForm,
      ReplyCommentForm,
      MainHeader,
      SearchBlock,
      TrustChart,
      MoreCommentsButtons
    },
    data: function() {
      return {
        //showReplyCommentForm: false,
        replyCommentFormShown: [],
        addedComments: [],
        summaryCommentFormShown: [],
        summaryCommentGreetingAll: [
          'Great input.',
          'Helpful as usual.',
          'You are the best.',
          'You will be rewarded.',
          'Pleasure to assist you.'
        ],
        summaryCommentGreetingToShow: []
        
        
 
      }
    },
    setup() {


      const gtag = inject('gtag');
      const { showBanner, okClicked } = useCookies(gtag);
      const okBannerClicked = () => okClicked();

           

      let urlObject = new URL(document.location.href)
      let params = urlObject.searchParams
      let reviewId = params.get("p")
      let commentPageNum = (i) =>{
         if(!params.get("n") || i>0){
          return "0"
         }
         else{
          return params.get("n")
         }
      }   
      const firstReviewId = reviewId
      let secondReviewId

      let commentClusterPerPage = 5
      
      let noAdsPage = inject('noAdsPage')
 
      let firstReviewTitle = ref([])
      let content = ref([])
      let content_shown = ref([])
      let contentList = ref([])
      
      let relatedContent = ref([])
      let relatedContentRightColumn = ref([])
      let relatedShown = 0
      let mainCategory = 0
      let categoryShown = 0
      let reviewType
      let secondReviewType
      let firstReviewType
      let adsLayout              //for Text reviews only
      let adsLayoutSecond        //second review
      let showSecondBlockAds = false
      let showFirstReviewInnerAds = true
      let isCategory = false
      let totalShown = 1
      let doFetch = true
      let adsListToShowGoogle = ref([])
      let summaryCommentGreetingShown = ref([])
      
      let commentBannerToShow = ref([])
      let commentBannerToShowAll = ref([])

      let promiseFetch

      let postBg = ref([])

      let contentBackgroundColor = ['#fbe3e8','#fceed1','#e5eaf5','#DCC7AA','#e4decd','#f7f7f7','#e1e8f0','#f1f0ee','#CAE4DB','#DFDCE3','#dfd8c8']
      let lastBgColor
      
      let isMobile = () => {
        if(window.innerWidth >420){
            return false
        }
        else{
          return true
        }
       }


 

  
      //first review google ad
       let googleAdTag = document.createElement('script')
       let googleAdTagHtml = "window.googletag = window.googletag || {cmd: []};"
       googleAdTagHtml += "googletag.cmd.push(function() {"
       googleAdTagHtml += "googletag.pubads().enableAsyncRendering();"
       googleAdTagHtml += "var mappingFirstTop = googletag.sizeMapping().addSize([420, 0], [[970, 250], [930, 180]]).addSize([0, 0], [[400,300],[336, 280], [320, 480],[300, 250]]).build();"
       googleAdTagHtml += "googletag.defineSlot('/1021376/ch1_ReviewStream_Top', [[970, 250], [930, 180],[400,300],[336, 280], [320, 480],[300, 250]], 'review-top-banner-"+reviewId+"').defineSizeMapping(mappingFirstTop).addService(googletag.pubads());"
       googleAdTagHtml += "googletag.pubads().collapseEmptyDivs();"
       googleAdTagHtml += "googletag.pubads().enableSingleRequest();"
       googleAdTagHtml += "googletag.enableServices();"
       googleAdTagHtml += "});"
       googleAdTag.innerHTML = googleAdTagHtml
       document.head.appendChild(googleAdTag)




       let loadGoogleAdCommentsInner = async (comment_relation) => {
       let googleAdTagComments = document.createElement('script')
       let googleAdTagHtmlComments = "googletag.cmd.push(function(){"
       googleAdTagHtmlComments += "var mappingComments = googletag.sizeMapping().addSize([420, 0], [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100]]).addSize([0, 0], [[336, 280], [320, 480],[320, 100],[300,600],[300, 250]]).build();"
       googleAdTagHtmlComments += "googletag.defineSlot('/1021376/ReviewStream_comments', [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100],[336, 280], [320, 480],[320, 100],[300,600],[300, 250]], 'comment-banner-"+comment_relation+"').defineSizeMapping(mappingComments).addService(googletag.pubads());"
       googleAdTagHtmlComments += "googletag.display('comment-banner-"+comment_relation+"');"
       googleAdTagHtmlComments += "googletag.pubads().collapseEmptyDivs();"
       googleAdTagHtmlComments += "googletag.pubads().enableSingleRequest();"
       googleAdTagHtmlComments += "googletag.enableServices();"
       googleAdTagHtmlComments += "});"
       googleAdTagComments.innerHTML = googleAdTagHtmlComments
       document.head.appendChild(googleAdTagComments)   
      }






       let loadGoogleAdFirstContentBasedText = async (id) => {
       let googleAdTagFirstContentBased = document.createElement('script')
       let googleAdTagHtmlFirstContentBased = "googletag.cmd.push(function() {"
       googleAdTagHtmlFirstContentBased += "var mappingFirstBottom = googletag.sizeMapping().addSize([420, 0], [[970, 250], [930, 180],[750, 300]]).addSize([0, 0], [[400,300],[336, 280], [320, 480],[300,600],[300, 250]]).build();"
       googleAdTagHtmlFirstContentBased += "var mappingFirstMiddle = googletag.sizeMapping().addSize([420, 0], [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100]]).addSize([0, 0], [[336, 280], [320, 480],[320, 100],[300,600],[300, 250]]).build();"
       googleAdTagHtmlFirstContentBased += "if(document.getElementById('inner-banner-middleone-"+id+"')){"
       googleAdTagHtmlFirstContentBased += "googletag.defineSlot('/1021376/ch1_ReviewStream_contentInner', [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100],[336, 280], [320, 480],[320, 100],[300,600],[300, 250]], 'inner-banner-middleone-"+id+"').defineSizeMapping(mappingFirstMiddle).addService(googletag.pubads());"
       googleAdTagHtmlFirstContentBased += "googletag.display('inner-banner-middleone-"+id+"');"
       googleAdTagHtmlFirstContentBased += "}"
       googleAdTagHtmlFirstContentBased += "googletag.defineSlot('/1021376/ch1_ReviewStream_underContent', [[970, 250], [930, 180],[750, 300],[400,300],[336, 280], [320, 480],[300,600],[300, 250]], 'inner-banner-bottom-"+id+"').defineSizeMapping(mappingFirstBottom).addService(googletag.pubads());"
       googleAdTagHtmlFirstContentBased += "googletag.display('inner-banner-bottom-"+id+"');"
       googleAdTagHtmlFirstContentBased += "googletag.pubads().collapseEmptyDivs();"
       googleAdTagHtmlFirstContentBased += "googletag.pubads().enableSingleRequest();"
       googleAdTagHtmlFirstContentBased += "googletag.enableServices();"
       googleAdTagHtmlFirstContentBased += "});"
       googleAdTagFirstContentBased.innerHTML = googleAdTagHtmlFirstContentBased
       document.head.appendChild(googleAdTagFirstContentBased)   
      }

      let loadGoogleAdFirstContentBasedImages = async (id) => {
       let googleAdTagFirstContentBased = document.createElement('script')
       let googleAdTagHtmlFirstContentBased = "googletag.cmd.push(function() {"
       googleAdTagHtmlFirstContentBased += "var mappingFirstBottom = googletag.sizeMapping().addSize([420, 0], [[970, 250], [930, 180],[750, 300]]).addSize([0, 0], [[400,300],[336, 280], [320, 480],[300,600],[300, 250]]).build();"
       googleAdTagHtmlFirstContentBased += "var mappingFirstMiddle = googletag.sizeMapping().addSize([420, 0], [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100]]).addSize([0, 0], [[336, 280], [320, 480],[320, 100],[300,600],[300, 250]]).build();"
       googleAdTagHtmlFirstContentBased += "googletag.defineSlot('/1021376/ch1_ReviewStream_contentInner', [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100],[336, 280], [320, 480],[320, 100],[300,600],[300, 250]], 'inner-banner-images-0-"+id+"').defineSizeMapping(mappingFirstMiddle).addService(googletag.pubads());"
       googleAdTagHtmlFirstContentBased += "googletag.defineSlot('/1021376/ch1_ReviewStream_contentInner', [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100],[336, 280], [320, 480],[320, 100],[300,600],[300, 250]], 'inner-banner-images-1-"+id+"').defineSizeMapping(mappingFirstMiddle).addService(googletag.pubads());"
       googleAdTagHtmlFirstContentBased += "googletag.defineSlot('/1021376/ch1_ReviewStream_contentInner', [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100],[336, 280], [320, 480],[320, 100],[300,600],[300, 250]], 'inner-banner-images-2-"+id+"').defineSizeMapping(mappingFirstMiddle).addService(googletag.pubads());"
       googleAdTagHtmlFirstContentBased += "googletag.defineSlot('/1021376/ch1_ReviewStream_contentInner', [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100],[336, 280], [320, 480],[320, 100],[300,600],[300, 250]], 'inner-banner-images-3-"+id+"').defineSizeMapping(mappingFirstMiddle).addService(googletag.pubads());"
       googleAdTagHtmlFirstContentBased += "googletag.defineSlot('/1021376/ch1_ReviewStream_contentInner', [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100],[336, 280], [320, 480],[320, 100],[300,600],[300, 250]], 'inner-banner-images-4-"+id+"').defineSizeMapping(mappingFirstMiddle).addService(googletag.pubads());"
       googleAdTagHtmlFirstContentBased += "googletag.defineSlot('/1021376/ch1_ReviewStream_underContent', [[970, 250], [930, 180],[750, 300],[400,300],[336, 280], [320, 480],[300,600],[300, 250]], 'inner-banner-images-bottom-"+id+"').defineSizeMapping(mappingFirstBottom).addService(googletag.pubads());"
       googleAdTagHtmlFirstContentBased += "googletag.display('inner-banner-images-0-"+id+"');"
       googleAdTagHtmlFirstContentBased += "googletag.display('inner-banner-images-1-"+id+"');"
       googleAdTagHtmlFirstContentBased += "googletag.display('inner-banner-images-2-"+id+"');"
       googleAdTagHtmlFirstContentBased += "googletag.display('inner-banner-images-3-"+id+"');"
       googleAdTagHtmlFirstContentBased += "googletag.display('inner-banner-images-4-"+id+"');"
       googleAdTagHtmlFirstContentBased += "googletag.display('inner-banner-images-bottom-"+id+"');"
       googleAdTagHtmlFirstContentBased += "googletag.pubads().collapseEmptyDivs();"
       googleAdTagHtmlFirstContentBased += "googletag.pubads().enableSingleRequest();"
       googleAdTagHtmlFirstContentBased += "googletag.enableServices();"
       googleAdTagHtmlFirstContentBased += "});"
       googleAdTagFirstContentBased.innerHTML = googleAdTagHtmlFirstContentBased
       document.head.appendChild(googleAdTagFirstContentBased)   
      }
      //end first review google ad




     let loadGoogleAdFirstReviewTop = async (id) => {
       let googleAdTop = document.getElementById('review-top-banner-'+id)
       let googleTagAd = document.createElement('script')
       googleTagAd.innerHTML = "googletag.cmd.push(function(){googletag.display('review-top-banner-"+id+"');});"
       //console.log('id: '+id+'...'+googleAdTop)
       googleAdTop.appendChild(googleTagAd)

     }
     let loadGoogleAdFirstReviewInner = async (id,reviewType) => {

       if(document.getElementById('inner-banner-middleone-'+id)){
          let googleAdFirstMiddle = document.getElementById('inner-banner-middleone-'+id)
          let googleTagAdFirstMiddle = document.createElement('script')
          googleTagAdFirstMiddle.innerHTML = "googletag.cmd.push(function(){googletag.display('inner-banner-middleone-"+id+"');});"
          googleAdFirstMiddle.appendChild(googleTagAdFirstMiddle)
       }
       if(document.getElementById('inner-banner-bottom-'+id)){
          let googleAdFirstBottom = document.getElementById('inner-banner-bottom-'+id)
          let googleTagAdFirstBottom = document.createElement('script')
          googleTagAdFirstBottom.innerHTML = "googletag.cmd.push(function(){googletag.display('inner-banner-bottom-"+id+"');});"
          googleAdFirstBottom.appendChild(googleTagAdFirstBottom)
       }
       if(document.getElementById('inner-banner-images-bottom-'+id)){
          let googleAdImagesBottom = document.getElementById('inner-banner-images-bottom-'+id)
          let googleTagAdImagesBottom = document.createElement('script')
          googleTagAdImagesBottom.innerHTML = "googletag.cmd.push(function(){googletag.display('inner-banner-images-bottom-"+id+"');});"
          googleAdImagesBottom.appendChild(googleTagAdImagesBottom)
       }
       if(reviewType==1 && document.getElementsByClassName('images-review-innerbanner')){
         let innerImagesBannerCount = document.getElementsByClassName('images-review-innerbanner').length
         for(let imagesBanner=0;imagesBanner<innerImagesBannerCount;imagesBanner++){
 //console.log('innerImagesBannerCount '+innerImagesBannerCount+'imagesBanner '+imagesBanner+' id '+id)
          let googleAdFirstImagesInner = document.getElementById('inner-banner-images-'+imagesBanner+'-'+id)
          let googleTagAdFirstImagesInner = document.createElement('script')
          googleTagAdFirstImagesInner.innerHTML = "googletag.cmd.push(function(){googletag.display('inner-banner-images-"+imagesBanner+"-"+id+"');});"
          googleAdFirstImagesInner.appendChild(googleTagAdFirstImagesInner)
          googleAdFirstImagesInner.className += ' images-review-innerbanner-filled'
         } 
       }

     }

     let googleAdSecondReview = async(id,reviewType) => {

       if(document.getElementById('inner-banner-middleone-'+id)){
          let googleAdFirstMiddle = document.getElementById('inner-banner-middleone-'+id)
          let googleTagAdFirstMiddle = document.createElement('script')
          googleTagAdFirstMiddle.innerHTML = "googletag.cmd.push(function(){googletag.display('inner-banner-middleone-"+id+"');});"
          googleAdFirstMiddle.appendChild(googleTagAdFirstMiddle)
       }
       if(document.getElementById('inner-banner-bottom-'+id)){
          let googleAdFirstBottom = document.getElementById('inner-banner-bottom-'+id)
          let googleTagAdFirstBottom = document.createElement('script')
          googleTagAdFirstBottom.innerHTML = "googletag.cmd.push(function(){googletag.display('inner-banner-bottom-"+id+"');});"
          googleAdFirstBottom.appendChild(googleTagAdFirstBottom)
       }
       if(document.getElementById('inner-banner-images-bottom-'+id)){
          let googleAdImagesBottom = document.getElementById('inner-banner-images-bottom-'+id)
          let googleTagAdImagesBottom = document.createElement('script')
          googleTagAdImagesBottom.innerHTML = "googletag.cmd.push(function(){googletag.display('inner-banner-images-bottom-"+id+"');});"
          googleAdImagesBottom.appendChild(googleTagAdImagesBottom)
       }
       if(reviewType==1 && document.getElementsByClassName('images-review-innerbanner')){
         let innerImagesBannerCount = document.getElementsByClassName('images-review-innerbanner').length
         let innerImagesBannerCountFilled = document.getElementsByClassName('images-review-innerbanner-filled').length
         innerImagesBannerCount = (innerImagesBannerCount - innerImagesBannerCountFilled)
         for(let imagesBanner=0;imagesBanner<innerImagesBannerCount;imagesBanner++){
  //console.log('innerImagesBannerCount '+innerImagesBannerCount+'imagesBanner '+imagesBanner+' id '+id)
          
          let googleAdFirstImagesInner = document.getElementById('inner-banner-images-'+imagesBanner+'-'+id)
          let googleTagAdFirstImagesInner = document.createElement('script')
          googleTagAdFirstImagesInner.innerHTML = "googletag.cmd.push(function(){googletag.display('inner-banner-images-"+imagesBanner+"-"+id+"');});"
          googleAdFirstImagesInner.appendChild(googleTagAdFirstImagesInner)
          googleAdFirstImagesInner.className += ' images-review-innerbanner-filled'
         } 
       }

     }




     let loadGoogleAdScroll = async (id) => {      //add top Ad on all of the reviews, starting from the second
       
       let googleAdTag_ = document.createElement('script')
       let googleAdTagHtml_ = "googletag.cmd.push(function() {"
       googleAdTagHtml_ += "var mappingSecondTop = googletag.sizeMapping().addSize([420, 0], [[970, 250], [930, 180]]).addSize([0, 0], [[400,300],[336, 280], [320, 480],[300, 250]]).build();"
       googleAdTagHtml_ += "googletag.defineSlot('/1021376/ch2_ReviewStream_Top', [[970, 250], [930, 180],[400,300],[336, 280], [320, 480],[300, 250]], 'review-top-banner-"+id+"').defineSizeMapping(mappingSecondTop).addService(googletag.pubads());"
       googleAdTagHtml_ += "googletag.display('review-top-banner-"+id+"');"
       googleAdTagHtml_ += "googletag.pubads().collapseEmptyDivs();"
       googleAdTagHtml_ += "googletag.pubads().enableSingleRequest();"
       googleAdTagHtml_ += "googletag.enableServices();"
       googleAdTagHtml_ += "});"
       googleAdTag_.innerHTML = googleAdTagHtml_
       document.head.appendChild(googleAdTag_)   
     }

     let loadGoogleAdSecondContentBasedText = async (id, adsLayout) => {
       let googleAdTagSecondContentBased = document.createElement('script')
       let googleAdTagHtmlSecondContentBased = "googletag.cmd.push(function() {"
       googleAdTagHtmlSecondContentBased += "var mappingSecondBottom = googletag.sizeMapping().addSize([420, 0], [[970, 250], [930, 180],[750, 300]]).addSize([0, 0], [[400,300],[336, 280], [320, 480],[300,600],[300, 250]]).build();"
       if(adsLayout == '1a' || adsLayout == '2'){
         googleAdTagHtmlSecondContentBased += "var mappingSecondMiddle = googletag.sizeMapping().addSize([420, 0], [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100]]).addSize([0, 0], [[336, 280], [320, 480],[320, 100],[300,600],[300, 250]]).build();"
         googleAdTagHtmlSecondContentBased += "googletag.defineSlot('/1021376/ch2_ReviewStream_contentInner', [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100],[336, 280], [320, 480],[320, 100],[300,600],[300, 250]], 'inner-banner-middleone-"+id+"').defineSizeMapping(mappingSecondMiddle).addService(googletag.pubads());"
       }
       googleAdTagHtmlSecondContentBased += "googletag.defineSlot('/1021376/ch2_ReviewStream_underContent', [[970, 250], [930, 180],[750, 300],[400,300],[336, 280], [320, 480],[300,600],[300, 250]], 'inner-banner-bottom-"+id+"').defineSizeMapping(mappingSecondBottom).addService(googletag.pubads());"
       googleAdTagHtmlSecondContentBased += "googletag.display('inner-banner-middleone-"+id+"');"
       googleAdTagHtmlSecondContentBased += "googletag.display('inner-banner-bottom-"+id+"');"
       googleAdTagHtmlSecondContentBased += "googletag.pubads().collapseEmptyDivs();"
       googleAdTagHtmlSecondContentBased += "googletag.pubads().enableSingleRequest();"
       googleAdTagHtmlSecondContentBased += "googletag.enableServices();"
       googleAdTagHtmlSecondContentBased += "});"
       googleAdTagSecondContentBased.innerHTML = googleAdTagHtmlSecondContentBased
       document.head.appendChild(googleAdTagSecondContentBased)   
     }


     let loadGoogleAdSecondContentBasedImages = async (id) => {
       let googleAdTagSecondContentBased = document.createElement('script')
       let googleAdTagHtmlSecondContentBased = "googletag.cmd.push(function() {"
       googleAdTagHtmlSecondContentBased += "var mappingSecondBottom = googletag.sizeMapping().addSize([420, 0], [[970, 250], [930, 180],[750, 300]]).addSize([0, 0], [[400,300],[336, 280], [320, 480],[300,600],[300, 250]]).build();"
       googleAdTagHtmlSecondContentBased += "var mappingSecondMiddle = googletag.sizeMapping().addSize([420, 0], [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100]]).addSize([0, 0], [[336, 280], [320, 480],[320, 100],[300,600],[300, 250]]).build();"
       googleAdTagHtmlSecondContentBased += "googletag.defineSlot('/1021376/ch2_ReviewStream_underContent', [[970, 250], [930, 180],[750, 300],[400,300],[336, 280], [320, 480],[300,600],[300, 250]], 'inner-banner-images-bottom-"+id+"').defineSizeMapping(mappingSecondBottom).addService(googletag.pubads());"
       googleAdTagHtmlSecondContentBased += "googletag.defineSlot('/1021376/ch2_ReviewStream_contentInner', [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100],[336, 280], [320, 480],[320, 100],[300,600],[300, 250]], 'inner-banner-images-0-"+id+"').defineSizeMapping(mappingSecondMiddle).addService(googletag.pubads());"
       googleAdTagHtmlSecondContentBased += "googletag.defineSlot('/1021376/ch2_ReviewStream_contentInner', [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100],[336, 280], [320, 480],[320, 100],[300,600],[300, 250]], 'inner-banner-images-1-"+id+"').defineSizeMapping(mappingSecondMiddle).addService(googletag.pubads());"
       googleAdTagHtmlSecondContentBased += "googletag.defineSlot('/1021376/ch2_ReviewStream_contentInner', [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100],[336, 280], [320, 480],[320, 100],[300,600],[300, 250]], 'inner-banner-images-2-"+id+"').defineSizeMapping(mappingSecondMiddle).addService(googletag.pubads());"
       googleAdTagHtmlSecondContentBased += "googletag.defineSlot('/1021376/ch2_ReviewStream_contentInner', [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100],[336, 280], [320, 480],[320, 100],[300,600],[300, 250]], 'inner-banner-images-3-"+id+"').defineSizeMapping(mappingSecondMiddle).addService(googletag.pubads());"
       googleAdTagHtmlSecondContentBased += "googletag.defineSlot('/1021376/ch2_ReviewStream_contentInner', [[980, 120],[970, 250],[930, 180], [750, 300], [750, 200],[750, 100],[336, 280], [320, 480],[320, 100],[300,600],[300, 250]], 'inner-banner-images-4-"+id+"').defineSizeMapping(mappingSecondMiddle).addService(googletag.pubads());"
       googleAdTagHtmlSecondContentBased += "googletag.display('inner-banner-middleone-"+id+"');"
       googleAdTagHtmlSecondContentBased += "googletag.display('inner-banner-bottom-"+id+"');"
       googleAdTagHtmlSecondContentBased += "googletag.pubads().collapseEmptyDivs();"
       googleAdTagHtmlSecondContentBased += "googletag.pubads().enableSingleRequest();"
       googleAdTagHtmlSecondContentBased += "googletag.enableServices();"
       googleAdTagHtmlSecondContentBased += "});"
       googleAdTagSecondContentBased.innerHTML = googleAdTagHtmlSecondContentBased
       document.head.appendChild(googleAdTagSecondContentBased)   
  
     }




    //add script to display google ad in every ad block
     let googleAdScript = (fullid) => {
       let adScriptDisplay = document.createElement('script')
       let adScriptDisplayCode = "googletag.cmd.push(function() {googletag.display('"+fullid+"');});"
       adScriptDisplay.innerHTML = adScriptDisplayCode      
       let adDiv = document.getElementById(fullid) 
       adDiv.appendChild(adScriptDisplay)
       //console.log('SCRIPT ADDED TO '+fullid)
       
     }







     function fetchFirstAd(noAdsPage){
          //console.log('noAdsPage '+noAdsPage)
          if(noAdsPage == false){
            let adScript = document.createElement('script')
            adScript.setAttribute('src', 'https://securepubads.g.doubleclick.net/tag/js/gpt.js')
            adScript.setAttribute('async','async')
            document.head.appendChild(adScript)
            setTimeout(function(){
              loadGoogleAdFirstReviewTop(firstReviewId)

            },2000)
          }
        }



     function showNextGoogleAds(id, reviewType) {
  //console.log('tut')
        if(showFirstReviewInnerAds == true){
//console.log('tut1')
         loadGoogleAdFirstReviewInner(id, reviewType)

         //setTimeout(function(){
//console.log('tut2 '+reviewType)           
          if(reviewType == 0){
            loadGoogleAdFirstContentBasedText(id)
  //console.log('tut3')          
          } 
          if(reviewType == 1){
            loadGoogleAdFirstContentBasedImages(id)
          } 
          
         //},300)
         showFirstReviewInnerAds = false
        }



        let el = document.getElementById('content-blck-'+id)
        var position = el.getBoundingClientRect()


          if(position.top < screen.height && showFirstReviewInnerAds == false && noAdsPage == false){

              
           
              if(showSecondBlockAds === true){
                loadGoogleAdScroll(secondReviewId)   //top second
           //console.log('STEP 2 - SHOW AD ID '+secondReviewId+' type: '+reviewType+'... showSecondBlockAds: '+showSecondBlockAds+' adsLayoutSecond '+adsLayoutSecond) 
 

               if(reviewType == 0){
                loadGoogleAdSecondContentBasedText(secondReviewId, adsLayoutSecond)
               } 
               if(reviewType == 1){
                loadGoogleAdSecondContentBasedImages(secondReviewId)
               } 
//console.log('A showSecondBlockAds '+showSecondBlockAds+' id '+id) 
                googleAdSecondReview(secondReviewId,reviewType)
              showSecondBlockAds = false
              }
              
              if(totalShown>2){
//console.log('B showSecondBlockAds '+showSecondBlockAds+' id '+id)                
                loadGoogleAdScroll(id)    //top all others
              }


//console.log('1.adsListToShowGoogle.value '+adsListToShowGoogle.value)
              adsListToShowGoogle.value.shift()
           }

     }

    
     



     let handleScroll = () => {


      //time to place banners
      if((window.innerHeight + window.scrollY) >= document.body.offsetHeight/3 && noAdsPage == false){


       if(!content_shown.value.includes(reviewId) && totalShown>1 && doFetch){
          fetchContent(reviewId,mainCategory,commentClusterPerPage)

        //  setTimeout(function(){
           if(adsListToShowGoogle.value.length>0 && noAdsPage == false){
            if(showFirstReviewInnerAds === true){
              showNextGoogleAds(firstReviewId, firstReviewType)
              //console.log('TUT')
            }
            else if(showSecondBlockAds === true){
              showNextGoogleAds(adsListToShowGoogle.value[0], secondReviewType)
              //console.log('TUT 1')
            }
            else{
              showNextGoogleAds(adsListToShowGoogle.value[0], reviewType)
              //console.log('TUT 2')
            }
           }
        //  },200) 

          doFetch = false
 
         } 
         else{
             //console.log('stopped '+reviewId)
         }
        






       let googleAdElements = document.getElementsByClassName('review-top-banner')
       for(let googleAdElement of googleAdElements){
         if(googleAdElement.innerHTML === ""){
           let googleAdElementId = googleAdElement.getAttribute('id')
 
           //console.log('STEP 1 - ADD SCRIPT INTO '+ googleAdElementId)
 
           googleAdScript(googleAdElementId)
 
         }
       } 

       //first review comments inner ads
       if(commentBannerToShow.value.length>0 && commentBannerToShow.value[0].length>0){

        let firstReviewCommentStart = document.getElementById('commentsClusterBlck-'+commentBannerToShow.value[0][0])
        let adsGoogleCommentsFirstReview = firstReviewCommentStart.getAttribute('data-ads')
        if(!adsGoogleCommentsFirstReview){
          var firstReviewCommentStartPos = firstReviewCommentStart.getBoundingClientRect()

          //console.log('firstReviewCommentStartPos '+firstReviewCommentStartPos.top+' screen.height '+screen.height)

          if(firstReviewCommentStartPos.top < screen.height){


            //console.log('tut')
             loadGoogleAdCommentsInner(commentBannerToShow.value[0][0])
             firstReviewCommentStart.setAttribute('data-ads', 'filled')
             commentBannerToShow.value[0].shift()
          }

        }

       }


       //second review comments inner ads
       if(commentBannerToShow.value.length>1 && commentBannerToShow.value[1].length>0){


         //console.log(commentBannerToShow.value[1])
         //console.log(commentBannerToShowAll.value)
         //console.log(commentBannerToShow.value[0][0])

         

        let secondReviewCommentStartStart = document.getElementById('commentsClusterBlck-'+commentBannerToShow.value[1][0])
        let adsGoogleCommentsFirstReview = secondReviewCommentStartStart.getAttribute('data-ads')
        if(!adsGoogleCommentsFirstReview){
          var secondReviewCommentStartStartPos = secondReviewCommentStartStart.getBoundingClientRect()

          //console.log('secondReviewCommentStartStartPos '+secondReviewCommentStartStartPos.top+' screen.height '+screen.height)

          if(secondReviewCommentStartStartPos.top < screen.height){


            //console.log('tut')
             loadGoogleAdCommentsInner(commentBannerToShow.value[1][0])
             secondReviewCommentStartStart.setAttribute('data-ads', 'filled')
             commentBannerToShow.value[1].shift()
          }

         }

        }



    //  }


    //    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight/2) {
    
        }







      }



      const fetchFirstTitle = async (r) =>{
          let firstTitleResponse
          try {
            if(r>0){
              //firstTitleResponse = await fetch('https://www.reviewstream.com/reviews/api/first-review-title.php?do='+r)
              
              firstTitleResponse = await fetch('../reviews/api/first-review-title.php?do='+r)
              
              const parsedFirstTitleResponse = await firstTitleResponse.json()
              firstReviewTitle.value = parsedFirstTitleResponse
            }
          } 
          catch(err) {
          //console.log(err) // state-of-the-art-error-handling
          }
      }





      const fetchContent = async (r,c,commentClusterPerPage,commentsPageNum) => {

         
        try {
              //console.log(relatedShown+'...'+JSON.stringify(relatedContent.value))
              //console.log('r '+r)  
              let mainResponse
              if(r>0){
                  //!!!!!!!!!!!!PAY ATTENTION THIS TEST API
                  //mainResponse = await fetch('https://www.reviewstream.com/reviews/api/review_test.php?do='+r+'&total='+totalShown+'&comments='+commentClusterPerPage+'&n='+commentsPageNum)
                  
                  // THIS ONE IS REAL
                  mainResponse = await fetch('../reviews/api/review.php?do='+r+'&total='+totalShown+'&comments='+commentClusterPerPage+'&n='+commentsPageNum)
                  
                  //console.log('GET REVIEW')
              }
              else{
                  //!!!!!!!!!!!PAY ATTENTION THIS TEST API
                  //mainResponse = await fetch('https://www.reviewstream.com/reviews/api/review_test.php?cat='+c+'&show='+categoryShown+'&total='+totalShown)
                  
                  // THIS ONE IS REAL
                  mainResponse = await fetch('../reviews/api/review.php?cat='+c+'&show='+categoryShown+'&total='+totalShown)

                  isCategory = true
                  //console.log('GET CATEGORY categoryShown '+categoryShown)
              }
              const parsedResponse = await mainResponse.json()

              //console.log('parsedResponse '+JSON.stringify(parsedResponse))

              if(JSON.stringify(parsedResponse) != 1){
                      content.value = parsedResponse



                      if(content.value.main[0].IDnum || content.value.main[0].no_cost == 1){
                        noAdsPage = true
                        //console.log('noAdsPage '+noAdsPage)
                      }

                      reviewType = content.value.main[0].submType
                      
                      adsLayout = content.value.main[0].ads_layout


                      if(totalShown == 1){
                        firstReviewType = reviewType
                      }

                      if(totalShown == 2){
                        secondReviewId = content.value.main[0].ID
                        adsLayoutSecond =  adsLayout 
                        secondReviewType = reviewType
                      }

                      //console.log('secondReviewId '+secondReviewId)

                      if(totalShown <= 2){

                        //if(content.value.comment_banner_place.length>0){
                          commentBannerToShow.value.push(content.value.comment_banner_place)

                          //commentBannerToShowAll.value.push(content.value.comment_banner_place)

                          commentBannerToShowAll.value = [...commentBannerToShowAll.value,...content.value.comment_banner_place]
                      
                          //commentBannerCount = commentBannerToShow.value.length
                          //console.log(' XXXXXXXXXXXXXXXXXXX '+ content.value.comment_banner_place)
                          //console.log('commentBannerToShowAll.value '+JSON.stringify(commentBannerToShowAll.value))
                        //}
                      }        
                  
                      if(mainCategory == 0){
                          mainCategory = content.value.main[0].post_category
                          //console.log('mainCategory '+mainCategory)
                      }

                      
                      
                      if(content.value.main[0].ID>0 && !content_shown.value.includes(content.value.main[0].ID)){

                    
                            contentList.value = [...contentList.value,content.value]

                            //post background color routine
                            const getRandomValue = (i, N) => Math.floor(Math.random() * (N - i) + i);
                            contentBackgroundColor.forEach( (elem, i, arr, j = getRandomValue(i, arr.length)) => [arr[i], arr[j]] = [arr[j], arr[i]] );
                            lastBgColor = contentBackgroundColor[contentBackgroundColor.length-1]
                            if(lastBgColor != contentBackgroundColor[0]){
                                postBg.value = [...postBg.value,...contentBackgroundColor]
                            }   
                            //end background color routine

                            content_shown.value.push(content.value.main[0].ID)
                            if(content.value.main[0].ID != firstReviewId){
                              adsListToShowGoogle.value.push(content.value.main[0].ID)
                              if(adsListToShowGoogle.value.length == 1){
                              
                                //setTimeout(function(){
                                showSecondBlockAds = true
                                //},2000)
                              }   
                            }
                            doFetch = true
                          

                            //console.log('showSecondBlockAds '+showSecondBlockAds)

                            totalShown++
                          
                            // if(isCategory){categoryShown++}

                            //console.log('TOTAL '+totalShown+'...cat '+categoryShown)


                      }






                      if(isCategory){categoryShown++}

             }
             
             
                      //console.log('tut '+relatedContent.value.length);  
                      if(relatedContent.value.length==0 || relatedContent.value.length==relatedShown){

                        
                                relatedContent.value = Object.values(content.value.related_reviews).filter(function(objFromA) {
                                        return !content_shown.value.find(function(objFromB) {
                                        return objFromA.related_id === objFromB
                                        })
                                        })

                                relatedContentRightColumn.value = [...relatedContentRightColumn.value,...relatedContent.value]



                                if(relatedContent.value.length == 0 && mainCategory > 0){
                                  reviewId = 0
                                //console.log('CATEGORY STARTED '+mainCategory)

                                  fetchContent(reviewId, mainCategory,commentClusterPerPage)




                                }
                                else{
                                  relatedShown=0
                                    //console.log(relatedShown+'--- '+JSON.stringify(relatedContent.value))

                                  reviewId = relatedContent.value[0].related_id
                                  //console.log('*** '+reviewId)
                                }




                      }
                      else{
                      reviewId = relatedContent.value[relatedShown].related_id
                      //console.log('tut '+relatedShown+'...'+reviewId)
                      }

             
                      relatedShown++




  
        } 
        catch(err) {
          //console.log(err) // state-of-the-art-error-handling
        }
        

      }

      onBeforeMount(() => {
        
        fetchFirstTitle(reviewId)

        //console.log('title '+this.firstReviewTitle)
      
        return new Promise(function(resolve, reject) {
          fetchContent(reviewId,mainCategory,commentClusterPerPage,params.get("n"))
        })
        .then(fetchFirstAd(noAdsPage))
        
      })
      onMounted(() => {

        

      

  
       

       window.addEventListener('scroll', handleScroll)

      
        

        //Lessen top menu routine
        ScrollTrigger.refresh();

        const topMenuScrollLessenStart = 'top 0'
        const topMenuScrollLessenEnd = 999999
        //const lineTimeline = gsap.timeline()
        
        ScrollTrigger.create({
            start: topMenuScrollLessenStart,
            end: topMenuScrollLessenEnd,
            toggleClass: {className: 'top-menu-icon-container-scrolled', targets: '.top-menu-icon-container'},
        });
        ScrollTrigger.create({
            start: topMenuScrollLessenStart,
            end: topMenuScrollLessenEnd,
            toggleClass: {className: 'top-menu-scrolled', targets: '.top-menu'},
        });
        ScrollTrigger.create({
            start: topMenuScrollLessenStart,
            end: topMenuScrollLessenEnd,
            toggleClass: {className: 'header-logo-scrolled', targets: '.header-logo'},
        });
        ScrollTrigger.create({
            start: topMenuScrollLessenStart,
            end: topMenuScrollLessenEnd,
            toggleClass: {className: 'header-moto-scrolled', targets: '.header-moto'},
        });
        ScrollTrigger.create({
            start: topMenuScrollLessenStart,
            end: topMenuScrollLessenEnd,
            toggleClass: {className: 'header-left-menu-scrolled', targets: '.header-left-menu'},
        });

        //end top menu lessen

        

 
          
        let OnEvent = (doc) => {
          return {
            on: async (type, selector, callback) => {
                doc.addEventListener(type, (event)=>{
                    if(!event.target.matches(selector)) return;
                    callback.call(event.target, event);
                }, false);
            }
          }
        };


        OnEvent(document).on('click', '.comment-outgoing-link', async function (e) {
         try{
            let commentId = e.target.id.split(':::')[0]
            let linknum = e.target.id.split(':::')[1]
    
            //console.log(commentId+'...'+linknum)

             const getOutgoingLinkUrl = "../reviews/outgoing_link_vue.php"
 
             let outLinkResponse
             let outLinkResponseData
             const outLinkOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ details: commentId, linknum: linknum })
             };
             
             outLinkResponse = await fetch(getOutgoingLinkUrl, outLinkOptions)

             outLinkResponseData = await outLinkResponse.json()
             let outLinkReply = JSON.stringify(outLinkResponseData)
             if(outLinkReply == 1){
                console.log('out link error')
             }
             else{  
               if(JSON.stringify(outLinkResponseData) != 1){         
                 //console.log(outLinkResponseData.link) 
                 //console.log(outLinkResponseData.title) 
 
                let outgoingLinkDisclaimer = '<div class="outgoing-link-disclaimer">Disclaimer: ReviewStream.com is not responsible for the contents of any web page referenced from this server.</div>'
                let showCommentLinkBlck = document.getElementById('commentsClusterBlck-'+commentId)
                let showCommentLinkTxt = '<div class="outgoing-link"><a href="'+outLinkResponseData.link+'" target="_blank">'+outLinkResponseData.title+'</a>'+outgoingLinkDisclaimer+'</div>'
                showCommentLinkBlck.innerHTML +=(showCommentLinkTxt)
               }
              }
           }
           catch(err) {
               console.log(err)
           }
        
     
         });


       
      })
      onUnmounted(() => {
        window.removeEventListener('scroll', handleScroll)
        
      })
      return {
        relatedContent,
        relatedContentRightColumn,
        contentList,
        postBg,
        showBanner,
        okBannerClicked,
        isMobile,
        summaryCommentGreetingShown,
        commentBannerToShow,
        commentBannerToShowAll,
        firstReviewTitle,
        commentClusterPerPage,
        commentPageNum,
        reviewId
      }
    },
    methods: {
    //  placeCommentBanner: (i) => {
    //     if(i%3){
    //       return true
    //     }
    //  },
    //  commentBannerCount: (commentBannerShown,commentBannerNum) => {
    //       commentBannerShown.push(commentBannerNum)
    //       commentBannerNum++
    //       console.log('commentBannerShown '+commentBannerShown)
    //       
    //  },
      imageWebpFileName: (filename) => {
        let imageNameBase = filename.split('.')[0]
        return imageNameBase+'.webp'

      },
      commentsCountText: (total) => {
         if(total>1){
           return "comments"
         }
         else{
           return "comment"
         }
      },
      isClusterStart: (relations) => {
        //console.log('relations '+relations)
        if (relations.match(/:/)) {
          return "commentsClusterBlck related-comment"
        }
      
       return "commentsClusterBlck"
      },
      postComment: (txt) => {
          return unescape(txt.replace(/\r?\n|\r/g, '<br>'))
      },
      commentBy: (c,a) => {
        let by
        if(!c){by = a+' says'}
        else if(!a){by = 'quick note by anonymous'}
        else if(c == 'Q'){by = a}
        else if(c == 'AA'){by = '<span class="author-comment-sign">author</span> '+a+' adds'}
        else{by = '<span class="author-comment-sign">author</span> '+a+' replies'}
        return by
      },
      addReplyCommentForm(r,replyCommentFormShown){

           replyCommentFormShown.push(r)

      },
      addSummaryCommentForm(review_id, summary_num, btn_clicked, summaryCommentFormShown){

          //console.log('summary_num '+summary_num)

          //console.log('summaryCommentFormShown   xxx '+summaryCommentFormShown)

           let newSummaryComment = {'review_id': review_id, 'summary_num': summary_num, 'btn_clicked': btn_clicked}

           //console.log('newSummaryComment '+JSON.stringify(newSummaryComment))

           summaryCommentFormShown.push(newSummaryComment)

           //console.log(summaryCommentFormShown)

           


      },
      showSummaryCommentsForm(review_id, summary_num, summaryCommentFormShown){


        //console.log('SHOW summaryCommentFormShown '+JSON.stringify(summaryCommentFormShown))
        //console.log('SHOW length '+summaryCommentFormShown.length)
        //console.log('SHOW review_id '+review_id+'...summary_num '+summary_num)
             
             //if(summaryCommentFormShown.some(summaryCommentFormShown => summaryCommentFormShown['review_id'] === review_id )){
             //  return true;
             //}
             let x = false
             for(let i=0;i<summaryCommentFormShown.length;i++){
               //console.log('SHOW tut.. '+summaryCommentFormShown[i].review_id)
               //console.log('SHOW tut... '+summaryCommentFormShown[i].summary_num)
               if(summaryCommentFormShown[i].review_id === review_id && summaryCommentFormShown[i].summary_num === summary_num){
                 //console.log('SHOW tut 1')
                 x = true;
               }
             }

            //console.log('xxxxx '+x)

          return x

      },
      showSummaryCommentGreeting(summaryCommentGreetingAll){
          if(this.summaryCommentGreetingToShow.length === 0){
            this.summaryCommentGreetingToShow = Array.from(summaryCommentGreetingAll)
          }
          //let's shuffle greeting
          for (let i = this.summaryCommentGreetingToShow.length - 1; i > 0; i--) {
            let j = Math.floor(Math.random() * (i + 1));
            [this.summaryCommentGreetingToShow[i], this.summaryCommentGreetingToShow[j]] = [this.summaryCommentGreetingToShow[j], this.summaryCommentGreetingToShow[i]];
          }
          //console.log('summaryCommentGreetingToShow '+this.summaryCommentGreetingToShow)

          let greetingToShow = this.summaryCommentGreetingToShow[0]
          //console.log('greetingToShow '+greetingToShow)
          this.summaryCommentGreetingToShow.shift()
          return '<div class="summary-greeting"><div class="summary-greeting-publish">Published.</div><div class="summary-greeting-text">'+greetingToShow+'</div><div class="summary-greeting-thanks">Thank you :)</div></div>' 

      },

      fetchSummaryCommentGreeting(summary_id,summaryCommentGreetingShown){
          return summaryCommentGreetingShown.find(x => x.summary === summary_id).greeting
      },
      ReadMoreClicked: async (event) => {

           let clickedDivPosition = event.target.getBoundingClientRect()
           let clickedDivFromTop = {
              top: clickedDivPosition.top + window.pageYOffset
           };
           let ReadMoreClickedResponse = await fetch('../reviews_vue/statistics/read-more-clicked-vue.php?top='+clickedDivFromTop.top)




      },
      likeSubmit: async (like,review_id,voting_url) => {
      
         //console.log('voting_url '+voting_url)

           if(like == 1){
                  let el = document.getElementById('dislike-review-'+review_id)
                  el.classList.add('collapse-dislike-blck')
            }
            if(like == 2){
                  let el = document.getElementById('like-review-'+review_id)
                  el.classList.add('collapse-like-blck')
            } 
       
        const reviewVoteUrl = "../reviews/votes_process_vue.php"

        try{

        
             let reviewVotePostResponse
             let reviewVotePostResponseData
             const reviewVotingOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ vurl: voting_url })
             };
             
             
             
             reviewVotePostResponse = await fetch(reviewVoteUrl, reviewVotingOptions)

             //console.log('reviewVotePostResponse '+ JSON.stringify(reviewVotePostResponse))

             reviewVotePostResponseData = await reviewVotePostResponse.json()
             
             //console.log('reviewVotePostResponseData '+reviewVotePostResponseData)

             let reviewVoteReply = JSON.stringify(reviewVotePostResponseData)
 
             //console.log('reviewVoteReply '+reviewVoteReply);

             if(reviewVoteReply == 1){
                if(like == 1){            //LIKE
                  let likeThanksSign = document.getElementById('like-thanks-'+review_id);
                  likeThanksSign.style.visibility = 'visible';
                }
                if(like == 2){            //DISLIKE
                  let dislikeThanksSign = document.getElementById('dislike-thanks-'+review_id);
                  dislikeThanksSign.style.visibility = 'visible';
 
                }
             }
             else{              //anything but sucess (when, for ex., both buttons clicked from same IP address)
                window.location.href = "/";
             }


        
          } 
          catch(err) {
            //console.log(err) // state-of-the-art-error-handling
          }
       
 
      },
      firstContentBlck(i){
        if(i==0){
          return " content-blck-first"
        }
        else{
          return ""
        }
      },
      contentCornerStyle(i){
        if(i<2){
          return " content-blck-corner-right"
        }
        else{
          return " content-blck-corner-left"
        }
      },
      searchBlockStyle(i,postBg){
          if(i<3){
            return 'border-right:3px solid '+postBg[i-1]
          }
          else{
            return 'border-left:2px solid #E66D29'
          }
      },
      clusterHelpfulVote: async (cluster, vote) => {

          
          const clusterVoteUrl = "../reviews/cluster_votes_vue.php"

          //const clusterVoteUrl = "https://www.reviewstream.com/reviews/cluster_votes_vue.php"


        try{

             let clusterVotePostResponse
             let clusterVotePostResponseData
             const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ cluster: cluster, vote: vote })
             };
 
             clusterVotePostResponse = await fetch(clusterVoteUrl, requestOptions)
             clusterVotePostResponseData = await clusterVotePostResponse.json()
             let clusterVoteReply = JSON.stringify(clusterVotePostResponseData)

             //console.log('clusterVoteReply '+clusterVoteReply)
    
              if(clusterVoteReply == 1){
                //console.log('votes')
                  let clusterUpdateVote = document.getElementById('cluster-vote-'+cluster)
                  let currentClusterVoteNum = parseInt(clusterUpdateVote.innerHTML)

                  if(vote == "1"){
                    clusterUpdateVote.innerHTML = (currentClusterVoteNum+1) 
                  }
                  if(vote == "2"){
                    clusterUpdateVote.innerHTML = (currentClusterVoteNum-1) 
                  }
              }


          } 
          catch(err) {
            //console.log(err) // state-of-the-art-error-handling
          }

      },
      submitComment: async (id,addedComments,relationId, summary_num,summaryCommentFormShown,summaryCommentGreetingShown, summaryCommentGreetingCurrent) =>{

           //console.log('!!! id: '+id+' ... relation: '+relationId);

            const commentUrl = "../reviews/questions_answers_vue.php"

            //const commentUrl = "https://www.reviewstream.com/reviews/questions_answers_vue.php"


            let commentTxt, commentAuthor, commentAuthorEmail
            let commentTxtInput, commentAuthorInput
            

            if(relationId){    //reply to other comment
             commentTxtInput = document.getElementById('comment-input-'+relationId)
             commentAuthorInput = document.getElementById('comment-author-input-'+relationId)
             commentTxt = document.getElementById('comment-input-'+relationId).value.trim();
             commentAuthor = document.getElementById('comment-author-input-'+relationId).value.trim();
             commentAuthorEmail = document.getElementById('comment-author-email-input-'+relationId).value.trim();
            }
            else if(summary_num>0){     //summary comment
             commentTxtInput = document.getElementById('comment-input-'+id+'-sum-'+summary_num)
             commentAuthorInput = document.getElementById('comment-author-input-'+id+'-sum-'+summary_num)
             commentTxt = document.getElementById('comment-input-'+id+'-sum-'+summary_num).value.trim();
             commentAuthor = document.getElementById('comment-author-input-'+id+'-sum-'+summary_num).value.trim();
             commentAuthorEmail = document.getElementById('comment-author-email-input-'+id+'-sum-'+summary_num).value.trim();
            }
            else{              //comment to the whole review from the main comment form
             commentTxtInput = document.getElementById('comment-input-'+id)
             commentAuthorInput = document.getElementById('comment-author-input-'+id)
             commentTxt = document.getElementById('comment-input-'+id).value.trim();
             commentAuthor = document.getElementById('comment-author-input-'+id).value.trim();
             commentAuthorEmail = document.getElementById('comment-author-email-input-'+id).value.trim();
            }
           
      
        
           if(!commentTxt || !commentAuthor){
             if(!commentTxt){
               commentTxtInput.style.background = '#ffff66'
               setTimeout(function(){commentTxtInput.style.background = '#ffffff'},1000)
               
             }
            if(!commentAuthor){
               commentAuthorInput.style.background = '#ffff66'
               setTimeout(function(){commentAuthorInput.style.background = '#ffffff'},1000)
               
             }

             return
           }
           else{


            //console.log('relation: '+relationId+'...submit comment '+id+'...commentTxt: '+commentTxt+'... urlyy:'+commentUrl);
      

         try{


             let commentPostResponse
             let commentPostResponseData
             const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ review_id: id, txt: commentTxt, name: commentAuthor, email: commentAuthorEmail, relation:relationId, sumquote:summary_num })
             };
             
             
             
             commentPostResponse = await fetch(commentUrl, requestOptions)
             commentPostResponseData = await commentPostResponse.json()
             let commentReply = JSON.stringify(commentPostResponseData)
             
             let commentResponseText = ''
            

             

             if(commentReply == 1){   //error
               commentResponseText = 'Oops, something went wrong. Sorry for the inconvenience.'
             }
             if(commentReply == 5){  //review author comment
                commentResponseText = 'Thank you <img src="../images/smiley_message.png" width=16 height=16 alt="smiley" title="smiley" loading="lazy"><br>Every comment increases your Trust Score.'
             }
             if(commentReply == 55){  //comment to review
                commentResponseText = 'Thank you <img src="../images/smiley_message.png" width=16 height=16 alt="smiley" title="smiley" loading="lazy"><br>We appreciate your effort to make an Internet more informative. The review&#39;s author was notified about your message. We suggest you to bookmark this page to follow conversation.'
             }
             if(commentReply == 555){  //reply to another comment
                commentResponseText = 'Thank you <img src="../images/smiley_message.png" width=16 height=16 alt="smiley" title="smiley" loading="lazy"><br>We appreciate your effort to make an Internet more informative. The review&#39;s and comment&#39;s authors were notified about your message. We suggest you to bookmark this page to follow conversation.'
             }
             
           
            if(summary_num>0){   //should be here, because of the input check above
               let summaryTxt = '<span id="comment_quote">re : '+document.getElementById('summary-'+summary_num+'-txt').textContent+'</span><br>'
               commentTxt = summaryTxt + commentTxt
             }
 
              let newCommentDetails = {}
              newCommentDetails.author = commentAuthor
              newCommentDetails.newcomment = commentTxt
              newCommentDetails.post_id = id
              newCommentDetails.relation_id = relationId
              newCommentDetails.greetingMsg = commentResponseText
       
              addedComments.push(newCommentDetails)

              //console.log('addedComments '+addedComments)

              if(relationId !=''){
                let newReplyBlck = document.getElementById('addReplyCommentBlck-'+relationId)
                fade(newReplyBlck)

                let repliedBtn = document.getElementById('reply-btn-'+relationId)
                repliedBtn.innerText = 'Replied'
                repliedBtn.style.background='#ffffff'
                repliedBtn.style.color='#192f97'


              }


              document.getElementById("comment-input-"+id).value = ''
              commentResponseText = ''



          } 
          catch(err) {
            //console.log(err) // state-of-the-art-error-handling
          }

        }
          //close summary comment from, that was just submitted
          if(summary_num>0){

            for(let i=0;i<summaryCommentFormShown.length;i++){
               //console.log('SHOW tut.. '+summaryCommentFormShown[i].review_id)
               //console.log('SHOW tut... '+summaryCommentFormShown[i].summary_num)
               if(summaryCommentFormShown[i].review_id === id && summaryCommentFormShown[i].summary_num === summary_num){
                 //console.log('SHOW tut 1')
                 summaryCommentFormShown.splice(i, 1);
               }
            }
          //let currentSummaryCommentGreeting = {'summary': id+'-'+summary_num,'greeting':this.showSummaryCommentGreeting(this.summaryCommentGreetingAll,this.summaryCommentGreetingToShow)}
          
          //console.log('currentSummaryCommentGreeting '+currentSummaryCommentGreeting) 

          summaryCommentGreetingShown.push({'summary': id+'-'+summary_num,'greeting':summaryCommentGreetingCurrent})

          //console.log('summaryCommentGreetingShown '+JSON.stringify(summaryCommentGreetingShown))
          }
         
      }
 


   }

  })

 </script>